import { render, staticRenderFns } from "./HomeCardsCard.vue?vue&type=template&id=22fac623&"
import script from "./HomeCardsCard.vue?vue&type=script&lang=js&"
export * from "./HomeCardsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports